import { render, staticRenderFns } from "./PictureManagerDeprecated.vue?vue&type=template&id=24ac20da&scoped=true&"
import script from "./PictureManagerDeprecated.vue?vue&type=script&lang=js&"
export * from "./PictureManagerDeprecated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac20da",
  null
  
)

export default component.exports